<template>
    <main>
        <section class="hero tw-relative">
            <div class="tw-container tw-relative">
                <h2 class="tw-text-white tw-text-center tw-mx-auto tw-hidden lg:tw-block">UN PROJET DE RÉNOVATION SOLS, MURS OU FENÊTRES ?</h2>
                <h1 class="tw-text-white tw-text-center tw-mx-auto"><span class="smaller">FAITES VOTRE DEMANDE DE DEVIS ET PROFITEZ DE</span><br>-15% DE RÉDUCTION<br><span>SUR VOTRE PRODUIT PRÉFÉRÉ JUSQU’AU 30/09</span></h1>
                <!-- <div class="badge tw-absolute tw-rounded-full tw-text-center tw-flex tw-flex-col tw-justify-center tw-items-center">
                    <p class="tw-text-white tw-uppercase tw-hidden lg:tw-block">BÉNEFICIEZ DE LA<br><span>TVA OFFERTE</span><br>SUR LES PRODUITS<br>POSÉS*</p>
                    <p class="tw-block lg:tw-hidden"><span>TVA</span><br><span class="tw-relative">OFFERTE</span></p>
                </div> -->
            </div>
        </section>

        <section class="form-container">
            <div class="tw-container">
                <h1 class="tw-text-center tw-pt-5 lg:tw-pt-10" v-if="!$store.state.formSuccess">ESTIMATION GRATUITE <span>ET</span> SANS ENGAGEMENT !</h1>
                <!-- <h1 class="tw-text-center tw-pt-5 lg:tw-pt-10" v-if="$store.state.formSuccess">MERCI</h1> -->
                <p class="tw-hidden lg:tw-block tw-text-center" v-if="!$store.state.formSuccess">Réalisez votre <b>estimation gratuite</b> et <b>sans engagement</b> et profitez d’un moment privilégié :<br>un expert se déplace chez vous gratuitement<sup>*</sup> !</p>
                <!-- <p class="tw-block tw-text-center tw-text-sm lg:tw-text-base" v-if="$store.state.formSuccess">Vous venez de réaliser votre demande de devis avec St Maclou.<br>Un conseiller vous rappelle très vite.</p> -->
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" />
            </div>
        </section>

        <section class="partner">
            <div class="tw-container tw-py-16">
                <h1 class="tw-text-center">ST MACLOU</h1>
                <h2 class="tw-text-center tw-pb-6 lg:tw-pb-4">PARTENAIRE DE TOUS VOS PROJETS MAISON</h2>
                <p class="tw-text-center tw-text-base tw-pb-12"><b>Leader sur le marché du revêtement</b> de sols et expert de la pose en France, St Maclou vous accompagne tout au long de votre projet, du choix de votre produit jusqu’à la pose. <b>Parquets, stratifiés, moquettes, sols vinyles ou naturels</b>… on répond à toutes vos envies !</p>
                <div class="carousel">
                    <div class="glide main__slider tw-relative tw-w-full lg:tw-pointer-events-none">
                        <div class="glide__track" data-glide-el="track">
                            <ul class="glide__slides tw-flex">
                                <!-- Slide 1 -->
                                <li class="glide__slide tw-relative tw-flex tw-items-center tw-justify-center tw-gap-6">
                                    <img src="~@/assets/img/photo-1.png">
                                </li>

                                <!-- Slide 2 -->
                                <li class="glide__slide tw-relative tw-flex tw-items-center tw-justify-center tw-gap-6">
                                    <img src="~@/assets/img/photo-2.png">
                                </li>

                                <!-- Slide 3 -->
                                <li class="glide__slide tw-relative tw-flex tw-items-center tw-justify-center tw-gap-6">
                                    <img src="~@/assets/img/photo-3.png">
                                </li>
                            </ul>

                            <div class="glide__bullets" data-glide-el="controls[nav]">
                                <button class="glide__bullet" data-glide-dir="=0"></button>
                                <button class="glide__bullet" data-glide-dir="=1"></button>
                                <button class="glide__bullet" data-glide-dir="=2"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-pt-6 lg:tw-pt-12">
                    <button class="btn-cta" v-scroll-to="'.form-container'">MON ESTIMATION GRATUITE</button>
                </div>
            </div>
        </section>

        <section class="advantages">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16">
                <h1 class="tw-text-center tw-up tw-uppercase">St Maclou, expert de la pose en France</h1>
                <h2 class="tw-text-center tw-pb-6 lg:tw-pb-10">TOUS LES AVANTAGES DU SERVICE</h2>
                <div class="tw-grid tw-grid-cols-2 lg:tw-flex tw-items-center tw-justify-around lg:tw-justify-between lg:tw-flex-row tw-gap-12 lg:tw-gap-16 tw-mx-auto">
                    <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img src="~@/assets/img/icons/guy.svg">
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img src="~@/assets/img/icons/tva.svg">
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img src="~@/assets/img/icons/five.svg">
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img src="~@/assets/img/icons/800_2.svg">
                    </div>
                    <div class="tw-hidden lg:tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img src="~@/assets/img/icons/70000.svg">
                    </div>
                </div>
                <div class="tw-block lg:tw-hidden tw-pt-12">
                    <img src="~@/assets/img/icons/70000.svg">
                </div>
            </div>
        </section>

        <section class="offer">
            <div class="tw-container tw-py-16">
                <h1 class="tw-text-center tw-pb-4 lg:tw-pb-5">RDV À DOMICILE OFFERT</h1>
                <p class="tw-text-center tw-text-sm lg:tw-text-2xl tw-text-white tw-pb-8">Réalisez votre <b>estimation gratuite</b> et <b>sans engagement</b> et profitez d’un moment privilégié : un expert se déplace chez vous gratuitement* pour prendre les mesures exactes de votre projet, vous conseiller sur la faisabilité et vous présenter des échantillons !</p>
                <div class="tw-flex tw-items-center tw-justify-center">
                    <button class="btn-cta yellow" v-scroll-to="'.form-container'">MON ESTIMATION GRATUITE</button>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Glide, { Autoplay, Controls, Swipe, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm';
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        Glide,
    },
    mounted() {
        new Glide('.main__slider', {
            type: 'slider',
            gap: 28,
            startAt: 0,
            perView: 3,
            peek: 0,
            breakpoints: {
                750: {
                    type: 'carousel',
                    perView: 1,
                    autoplay: 3000,
                }
            }
        }).mount({ Controls, Autoplay, Swipe, Breakpoints });
    },
};
</script>
